import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../mock';

const GalleriaSection = () => {
  const { t } = useLanguage();
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.05, margin: '0px 0px -100px 0px' });

  return (
    <section id="galleria" ref={ref} className="relative py-32 bg-[#2A2520]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Number */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-9xl font-serif text-[#F5F1E8]/10 absolute top-10 left-6"
        >
          03
        </motion.div>

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16 relative z-10"
        >
          <h2 className="text-5xl md:text-6xl font-serif text-[#F5F1E8] mb-4">
            {t.nav.galleria}
          </h2>
        </motion.div>

        {/* Masonry Columns Layout - preserves image aspect ratios */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {images.gallery.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ scale: 1.02 }}
              className="relative overflow-hidden break-inside-avoid cursor-pointer group"
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                loading="lazy"
                className="w-full h-auto block"
              />
              <div className="absolute inset-0 bg-[#2A2520]/0 group-hover:bg-[#2A2520]/20 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleriaSection;
